import i18n from '@/libs/i18n'

export default [
  {
    path: '/create-campaign-video',
    name: 'CreateCampaignVideo',
    component: () => import('@/views/video-generation-2/VideoGeneration.vue'),
    meta: {
      pageTitle: i18n.t('videoGeneration.textPageTitle'),
      requireAuth: true,
      requireUpdateInfo: true,
      hasGrayBg: true,
      layout: 'vertical',
    },
  },
  {
    path: '/generated-library',
    name: 'GeneratedLibrary',
    component: () => import('@/views/video-generation-2/VideoGenerationLibrary.vue'),
    meta: {
      pageTitle: i18n.t('videoGeneration.textGeneratedLibrary'),
      requireAuth: true,
      requireUpdateInfo: true,
      hasGrayBg: true,
      layout: 'vertical',
    },
  },
]
